import { render, staticRenderFns } from "./ProzessSidebarModalWrapper.vue?vue&type=template&id=68702b46"
import script from "./ProzessSidebarModalWrapper.vue?vue&type=script&lang=js"
export * from "./ProzessSidebarModalWrapper.vue?vue&type=script&lang=js"
import style0 from "./ProzessSidebarModalWrapper.vue?vue&type=style&index=0&id=68702b46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports